var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "filter-container" }),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "", stripe: "", fit: "" } },
        [
          _c("el-table-column", { attrs: { type: "index" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { sortable: "", label: "Tiêu đề", prop: "title" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { sortable: "", label: "Loại", prop: "type" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(_vm._s(_vm.TYPE_CONTENT_DEFINE[row.type]))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Nội dung" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.$store.state.user.info.area
                              ? _vm.handleView(row)
                              : _vm.handleUpdate(row)
                          },
                        },
                      },
                      [_vm._v("Xem chi tiết")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Hành động" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.$store.state.user.info.area
                              ? _vm.handleView(row)
                              : _vm.handleUpdate(row)
                          },
                        },
                      },
                      [_vm._v("Cập nhật")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title:
              _vm.dialogStatus == "update"
                ? "Cập nhật tin tức"
                : "Thêm tin tức",
            visible: _vm.dialogVisible,
            width: "1200px",
            top: "15px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-width": "80px",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Tiêu đề",
                                        prop: "title",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.formData.title,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.formData, "title", $$v)
                                          },
                                          expression: "formData.title",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Loại", prop: "type" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            disabled: "",
                                            placeholder: "",
                                          },
                                          model: {
                                            value: _vm.formData.type,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "type",
                                                $$v
                                              )
                                            },
                                            expression: "formData.type",
                                          },
                                        },
                                        _vm._l(
                                          _vm.TYPE_CONTENT_DEFINE,
                                          function (value, key) {
                                            return _c("el-option", {
                                              key: key,
                                              attrs: {
                                                label: value,
                                                value: key,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _vm.formData.type != "TERM_CONDITION"
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "Mô tả", prop: "body" } },
                                [
                                  _c("Tinymce", {
                                    ref: "editor",
                                    attrs: {
                                      width: "100%",
                                      height: 400,
                                      disabled: _vm.dialogStatus == "view",
                                    },
                                    model: {
                                      value: _vm.formData.body,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "body", $$v)
                                      },
                                      expression: "formData.body",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "el-form-item",
                                { attrs: { label: "Giá trị", prop: "body" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.formData.body,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "body", $$v)
                                      },
                                      expression: "formData.body",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-upload",
                                    {
                                      staticStyle: { "margin-top": "10px" },
                                      attrs: {
                                        name: "image",
                                        drag: "",
                                        action:
                                          _vm.baseUrl +
                                          "/contentDefine/image/upload",
                                        "on-success":
                                          _vm.handleUploadSuccessFile,
                                        "show-file-list": false,
                                        headers: {
                                          token: _vm.token,
                                          version: _vm.$version,
                                        },
                                        accept: ".pdf",
                                      },
                                    },
                                    [
                                      true
                                        ? [
                                            _c("i", {
                                              staticClass: "el-icon-upload",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "el-upload__text",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Kéo thả vào đây hoặc\n                    "
                                                ),
                                                _c("em", [
                                                  _vm._v(
                                                    "click vào để upload pdf"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("Đóng")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.submitLoading, type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogStatus == "create"
                        ? _vm.createData()
                        : _vm.updateData()
                    },
                  },
                },
                [_vm._v("Đồng ý")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }